const eventTypes = ['mouseover', 'mouseout'];

const elements = [...document.getElementsByTagName('i')]

elements.forEach((elem)=> {
    const toolTipElement = elem.parentElement.nextElementSibling;
    if(toolTipElement && toolTipElement.getAttribute('role')==='tooltip') {
        eventTypes.forEach((event) => {
            elem.addEventListener(event, (e) => {
                toolTipElement.classList.toggle('u-hidden'); 
                e.stopPropagation();
            }, false)
        })
    }
})